import { ThemeConfig } from '@telescope/cassini-ui';
import { foundations } from './foundations';
import { components } from './components';

const config: ThemeConfig = {
  useSystemColorMode: false,
  cssVarPrefix: 'cassini',
};

// Base Theme is merged with theme from widget. Widget theme has higher precedence and overrides base theme values
export const baseTheme = {
  config,
  components,
  ...foundations,
};
